export const EMPRESA = {
  SECURITIZADORA: 7,
  FIDC: 6
};
